<nav class="navbar  navbar-light green-theme" role="navigation">
<div class="nav nav-justified navbar-nav expand-width">
    <span class="logo-span nav-item">
      <a [routerLink]="home_link"><img src="/assets/images/boldungu_logo.png" width="40"/></a>
    </span>
    <span style="font-size:30px;cursor:pointer" onclick="openNav()" class="nav-item">&#9776; open</span>
</div>
</nav>
<div id="mySidenav" class="sidenav">
    <a href="javascript:void(0)" class="closebtn" onclick="closeNav()">&times;</a>
    <span *ngIf="gatePass.is_role_admin" class="nav-item dropdown main-nav-drop">
      <app-menu-item-user-admin ></app-menu-item-user-admin>
    </span>

      <app-menu-item-home  *ngIf="gatePass.is_logged_in"
      [student]="student"
      [guardian]="guardian"
      [gatePass]="gatePass"></app-menu-item-home>

    <span *ngIf="!gatePass.is_logged_in"  class="nav-item">
      <a [routerLink]="['static/display/service/offering']" class="nav-link">
        <div>Services</div></a>
    </span>
    <span *ngIf="!gatePass.is_logged_in" class="nav-item">
      <a [routerLink]="['info/access/plans']" class="nav-link"> <div>Pricing</div></a>
    </span>
    <span *ngIf="(gatePass.is_role_student || gatePass.is_role_guardian)&& gatePass.is_logged_in" class="nav-item dropdown main-nav-drop">
      <app-report-menu [gatePass]="gatePass"></app-report-menu>
    </span>
    <span *ngIf="(gatePass.is_role_student || gatePass.is_role_guardian) && gatePass.is_logged_in"  class="nav-item">
      <a [routerLink]="['study/material/index/',gatePass.user_id]" class="nav-link ">
        <div> Study Material </div> </a>
    </span>
    <span *ngIf="!gatePass.is_role_student && gatePass.is_logged_in" class="nav-item dropdown main-nav-drop">
        <app-guardian-tools-and-services [gatePass]="gatePass">
      </app-guardian-tools-and-services>
    </span>
    <span *ngIf="gatePass.is_role_student" class="nav-item">
        <a [routerLink]="['/student/messaging/home',gatePass.user_id]"  class="nav-link "><div class="button"><span class="button__badge">0</span></div><div>Messaging</div> </a>
    </span>
    <span *ngIf="!gatePass.is_logged_in" class="nav-item dropdown main-nav-drop">
      <app-about-us-menu-item></app-about-us-menu-item>
    </span>
    <span class="nav-item" *ngIf="!gatePass.is_logged_in">
     <a [routerLink]="['info/gallery/preview']"  class="nav-link ">
      <div> Gallery </div>
      </a>
    </span>

    <span class="nav-item px-2" *ngIf="!gatePass.is_logged_in">
      <a [routerLink]="['user/login']" class="nav-link"><div>Login</div></a>
    </span>
      <span class="nav-item px-2" *ngIf="!gatePass.is_logged_in">
        <a [routerLink]="['/user/new/step/one']"  class="nav-link"> <div>Register for free</div> </a>
      </span>
      <span *ngIf="gatePass.is_logged_in"class="nav-item dropdown main-nav-drop">
        <app-menu-item-user ></app-menu-item-user>
      </span>
  </div>
